import {Component, HostListener, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import { Location } from '@angular/common';
import {ReservedQrStateService} from "../service/reserved-qr-state-service";

@Component({
  selector: 'app-reserved-qr-activation-page',
  templateUrl: './reserved-qr-activation-page.component.html',
  styleUrl: './reserved-qr-activation-page.component.scss'
})
export class ReservedQrActivationPageComponent implements OnInit {

  reservedIdentificationId: string | null = null;

  isMobile: boolean = window.innerWidth <= 768;

  constructor(
    private router: Router,
    private location: Location,
  ) {
  }

  ngOnInit() {
    this.reservedIdentificationId = history.state.reservedIdentificationId || null;
    this.checkReservedIdentification();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: UIEvent): void {
    const target = event.target as Window;
    this.isMobile = target.innerWidth <= 768;
  }

  checkReservedIdentification() {
    if (!this.reservedIdentificationId) {
      this.router.navigate(['/error-page']);
    }
  }

  protected activateBusinessCard() {
    if (this.reservedIdentificationId) {
      ReservedQrStateService.setReservedId(this.reservedIdentificationId);
      this.router.navigate(['/cards'], {
        state: { reservedIdentificationId: this.reservedIdentificationId }
      });
    }
  }

  protected cancel() {
    this.location.back();
  }
}
